import React, { useEffect, useState } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axiosInstance from "../axiosInstance";
import { useParams, useNavigate } from "react-router-dom";
import UserLayout from "../components/UserLayout";
import LoadingState from "../components/ui/LoadingState";
import { BiArrowBack } from "react-icons/bi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_URL_All } from "../api";
const API_URL = `${API_URL_All}/api/import-orders`; // API URL chuẩn
const EditOrderUser = () => {
  const { id } = useParams(); // Lấy ID từ URL
  const navigate = useNavigate(); // Điều hướng sau khi cập nhật thành công
  const [order, setOrder] = useState(null); // State lưu dữ liệu đơn hàng
  const [units, setUnits] = useState([]);
  const [lines, setLines] = useState([]);
  const [statuses, setStatuses] = useState([]);

  // Lấy dữ liệu đơn hàng khi có ID
  useEffect(() => {
    if (id) {
      fetchOrderDetails(id);
    }
  }, [id]);

  const fetchOrderDetails = async (orderId) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/${orderId}`);
      setOrder(response.data);
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu:", error);
    }
  };

  // Lấy danh sách Units, Lines, Statuses
  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchWithCheck = async (url) => {
          const response = await fetch(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
              Accept: "application/json",
            },
          });
          if (!response.ok) {
            console.error(`Lỗi lấy dữ liệu từ ${url}:`, response.statusText);
            return [];
          }
          return response.json();
        };

        const [unitData, lineData, statusData] = await Promise.all([
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/2`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/1`),
          fetchWithCheck(`${API_URL_All}/api/model-details/by-model/3`),
        ]);

        setUnits(unitData);
        setLines(lineData);
        setStatuses(statusData);
      } catch (error) {
        console.error("Lỗi khi tải dữ liệu:", error);
      }
    };

    fetchData();
  }, []);

  // Validation Schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Vui lòng nhập Tên sản phẩm"),
    lineId: Yup.string().required("Vui lòng nhập Line"),
    //  packageUnitValue: Yup.number()
    //             .typeError("Vui lòng nhập Khối lượng")
    //             .required("Khối lượng là bắt buộc"),
              insurancePrice: Yup.number()
                .typeError("Vui lòng nhập Giá bảo hiểm")
                .required("Giá bảo hiểm là bắt buộc"),
  });

  const handleSubmit = async (values) => {
    if (order.locked) {
      toast.error("Đơn hàng đã được tiếp nhận nên sẽ không thể thay đổi thông tin. Mọi thắc mắc vui lòng liên hệ bộ phận CSKH", { position: "top-right" });
      return;
    }

    try {
      const response = await axiosInstance.put(`${API_URL}/${id}`, values, {
        headers: { "Content-Type": "application/json" },
      });
      toast.success("Cập nhật thành công đơn hàng!", { position: "top-right" });
      navigate("/order");
    } catch (error) {
      console.error("Lỗi khi cập nhật:", error);
      toast.error("Đơn hàng đã được tiếp nhận nên sẽ không thể thay đổi thông tin. Mọi thắc mắc vui lòng liên hệ bộ phận CSKH", { position: "top-right" });
    }
  };

  if (!order) {
    return (
      <UserLayout>
        <LoadingState label="Đang tải dữ liệu…" />
      </UserLayout>
    );
  }

  return (
    <UserLayout>
      <div className="container my-2">
        <h2 className="text-center flex-grow-1 mb-4">Cập nhật đơn hàng</h2>

        <Formik
          initialValues={{
            name: order.name || "",
            packageNumbers: order.packageNumbers || "",
            packageUnitValue: order.packageUnitValue || "",
            insurancePrice: order.insurancePrice || "",
            shippingMethod: order.shippingMethod || "",
            cnShippingCode: order.cnShippingCode || "",
            lineId: order.lineId ? order.lineId.id : "",  // Chỉ lấy id
           packageUnitM3: order.packageUnitM3  || "" // Chỉ lấy id
          }}
          enableReinitialize={true}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values }) => (
            <Form className="row g-3 fw-bold">
              <div className="col-md-6">
                <label className="form-label">Line <span className="text-danger">*</span></label>
                <Field as="select" className="form-control" name="lineId" disabled={order.locked}>
                  <option value="">--Chọn--</option>
                  {lines.map((line) => (
                    <option key={line.id} value={line.id}>{line.name}</option>
                  ))}
                </Field>
                <ErrorMessage name="lineId" component="div" className="text-danger" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Tên sản phẩm <span className="text-danger">*</span></label>
                <Field type="text" className="form-control" name="name" disabled={order.locked} />
                <ErrorMessage name="name" component="div" className="text-danger" />
              </div>
              <div className="col-md-6">
                <label className="form-label mb-3">Mã vận đơn Trung Quốc</label>
                <Field type="text" className="form-control" name="cnShippingCode" disabled={order.locked} />
              </div>
              <div className="col-md-6"></div>
             
              <div className="col-md-3">
                <label className="form-label">Số lượng kiện hàng</label>
                <Field type="number" className="form-control" name="packageNumbers" disabled={order.locked} />
              </div>
              <div className="col-md-2">
                              <label className="form-label">M3 <span className="text-danger"></span></label>
                              <Field
                                type="number"
                                className="form-control"
                                name="packageUnitM3"
                                disabled={values.locked}
                                min="0"
                                step="any"
                              />
                              <ErrorMessage name="packageUnitM3" component="div" className="text-danger" />
                            </div>
              <div className="col-md-3">
                <label className="form-label">Khối lượng <span className="text-danger"></span></label>
                <Field type="number" className="form-control" name="packageUnitValue" disabled={order.locked} />
                <ErrorMessage name="packageUnitValue" component="div" className="text-danger" />
              </div>
              <div className="col-md-3">
                <label className="form-label">Giá bảo hiểm<span className="text-danger">*</span></label>
                <Field type="number" className="form-control" name="insurancePrice"  disabled={order.locked}/>
                  <ErrorMessage name="insurancePrice" component="div" className="text-danger" />
              </div>
              <div className="col-md-6">
                <label className="form-label">Phương thức lấy hàng</label>
                <Field as="textarea" className="form-control" name="shippingMethod" disabled={order.locked} />
              </div>

              <div className="col-12 text-center">
                <button type="submit" className="btn btn-success px-5 py-2 me-3">Cập nhật</button>
                <button className="btn btn-secondary py-2 me-3" onClick={() => navigate("/order")}>Quay lại</button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </UserLayout>
  );
};

export default EditOrderUser;
